import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './Categories.css';

const Categories: React.FC = () => {
  const navigate = useNavigate();

  const categories = [
    { id: 1, name: 'English', icon: '🇬🇧', description: 'Learn English language and literature', courses: 45 },
    { id: 2, name: 'Mathematics', icon: '🔢', description: 'From basics to advanced mathematics', courses: 38 },
    { id: 3, name: 'Science', icon: '🔬', description: 'Physics, Chemistry, Biology', courses: 52 },
    { id: 4, name: 'History', icon: '📜', description: 'World history and civilizations', courses: 28 },
    { id: 5, name: 'Art & Design', icon: '🎨', description: 'Creative arts and design principles', courses: 33 },
    { id: 6, name: 'Spanish', icon: '🇪🇸', description: 'Learn Spanish language', courses: 25 },
    { id: 7, name: 'Computer Science', icon: '💻', description: 'Programming and technology', courses: 41 },
    { id: 8, name: 'Business', icon: '💼', description: 'Business and management courses', courses: 29 }
  ];

  return (
    <div className="categories-page">
      <header className="categories-header">
        <button className="back-button" onClick={() => navigate('/')}>
          ←
        </button>
        <h1>Categories</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="categories-content">
        <div className="categories-grid">
          {categories.map((category) => (
            <div key={category.id} className="category-card" onClick={() => navigate(`/category/${category.id}`)}>
              <div className="category-icon-large">{category.icon}</div>
              <h3 className="category-name-large">{category.name}</h3>
              <p className="category-description">{category.description}</p>
              <div className="category-courses-count">{category.courses} Courses</div>
            </div>
          ))}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Categories;

